if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
      
      // Gruplanmış varyantlar için click ve keyboard event listener ekle
      const handleGroupedVariantSelection = (event) => {
        // Label veya içindeki span elementine tıklandığında yakala
        const label = event.target.closest('.m-product-option--grouped-variant');
        if (label && label.dataset.productUrl) {
          event.preventDefault();
          event.stopPropagation();
          
          // Eğer zaten seçiliyse, tekrar tıklamayı engelle
          if (label.dataset.selected === 'true') {
            return;
          }
          
          // Diğer seçili label'ları temizle
          this.querySelectorAll('.m-product-option--grouped-variant[data-selected="true"]').forEach((el) => {
            el.removeAttribute('data-selected');
          });
          
          // Yeni label'ı seçili yap
          label.setAttribute('data-selected', 'true');
          
          // Seçili değeri güncelle
          const optionInner = label.closest('.m-product-option__inner');
          if (optionInner) {
            const selectedValueSpan = optionInner.querySelector('.option-label--selected');
            if (selectedValueSpan && label.dataset.value) {
              selectedValueSpan.textContent = label.dataset.value;
            }
          }
          
          // Event'i emit et
          MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { 
            data: { 
              selectedOptionValues: this.selectedOptionValues, 
              event, 
              target: label 
            } 
          });
        }
      };
      
      this.addEventListener('click', handleGroupedVariantSelection);
      
      // Keyboard desteği (Enter ve Space)
      this.addEventListener('keydown', (event) => {
        const label = event.target.closest('.m-product-option--grouped-variant');
        if (label && (event.key === 'Enter' || event.key === ' ')) {
          handleGroupedVariantSelection(event);
        }
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}